import React from 'react';
import { Element, FontType, Color } from '@americanexpress/aqx-components';
import clsx from 'clsx';

import styles from './__styles__/index.scss?modules';

const Flag = ({ text, className }) => (
  <Element
    className={clsx(styles.flag, className)}
    theme={{ fontType: FontType.BentonBold, color: Color.Black }}
  >
    {text}
  </Element>
);

export default Flag;
